import {createFileRoute} from "@tanstack/react-router";
import {offerTemplateItemMessages} from "../../-messages/offer-template-item.messages";
import {OfferTemplatePreviewPage} from "./-page/offer-template-preview.page";
import {OfferTemplatePreviewPending} from "./-page/offer-template-preview.pending";

export const Route = createFileRoute("/_app/sales/offers/templates/$offerTemplateId/preview/")({
  component: RouteComponent,
  pendingComponent: OfferTemplatePreviewPending,
  staticData: {meta: {labelDescriptor: offerTemplateItemMessages.preview}},
});
function RouteComponent() {
  const {offerTemplateId} = Route.useParams();
  return <OfferTemplatePreviewPage offerTemplateId={offerTemplateId} />;
}
